module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _vm._v("KEY TO NEW YORK WALKS MAP")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07chapter01#ch1"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("1.")]), _vm._v(" Battery Park")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08chapter02#ch2"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("2.")]), _vm._v(" Wall Street")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09chapter03#ch3"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("3.")]), _vm._v(" Ground Zero and The Freedom Tower")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10chapter04#ch4"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("4.")]), _vm._v(" South Street Seaport")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11chapter05#ch5"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("5.")]), _vm._v(" Brooklyn Bridge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12chapter06#ch6"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("6.")]), _vm._v(" City Hall")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13chapter07#ch7"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("7.")]), _vm._v(" TriBeCa")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/14chapter08#ch8"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("8.")]), _vm._v(" SoHo")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/15chapter09#ch9"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("9.")]), _vm._v(" NoLita")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/16chapter10#ch10"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("10.")]), _vm._v(" Little Italy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/17chapter11#ch11"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("11.")]), _vm._v(" Chinatown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/18chapter12#ch12"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("12.")]), _vm._v(" Lower East Side, Part 1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/19chapter13#ch13"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("13.")]), _vm._v(" Lower East Side, Part 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/20chapter14#ch14"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("14.")]), _vm._v(" East Village")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/21chapter15#ch15"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("15.")]), _vm._v(" Greenwich Village, Part 1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/22chapter16#ch16"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("16.")]), _vm._v(" Greenwich Village, Part 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/23chapter17#ch17"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("17.")]), _vm._v(" Greenwich Village, Part 3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/24chapter18#ch18"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("18.")]), _vm._v(" The Meatpacking District")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/25chapter19#ch19"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("19.")]), _vm._v(" Chelsea")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/26chapter20#ch20"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("20.")]), _vm._v(" The High Line")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/27chapter21#ch21"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("21.")]), _vm._v(" Union Square")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/28chapter22#ch22"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("22.")]), _vm._v(" Midtown Landmarks 1: Empire State Building, Morgan Library, and the United Nations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/29chapter23#ch23"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("23.")]), _vm._v(" Midtown Landmarks 2: Grand Central Station, Bryant Park, and the New York Public Library")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/30chapter24#ch24"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("24.")]), _vm._v(" Times Square")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/31chapter25#ch25"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("25.")]), _vm._v(" Rockefeller Center")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/32chapter26#ch26"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("26.")]), _vm._v(" MoMA and Fifth Avenue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/33chapter27#ch27"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("27.")]), _vm._v(" Central Park: Kid Zone")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/34chapter28#ch28"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("28.")]), _vm._v(" Central Park: 72nd Street to the Frick")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/35chapter29#ch29"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("29.")]), _vm._v(" The Met and Central Park (The Great Lawn and the Ramble)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/36chapter30#ch30"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("30.")]), _vm._v(" A Magical Trio: The Guggenheim Museum, the Cooper-Hewitt, and the Central Park Reservoir")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/37chapter31#ch31"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("31.")]), _vm._v(" Madison Avenue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/38chapter32#ch32"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("32.")]), _vm._v(" The Upper West Side")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/39chapter33#ch33"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("33.")]), _vm._v(" Riverside Park")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/40chapter34#ch34"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("34.")]), _vm._v(" Columbia University")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/41chapter35#ch35"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("35.")]), _vm._v(" Harlem, Part 1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/42chapter36#ch36"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("36.")]), _vm._v(" Harlem, Part 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/43chapter37#ch37"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("37.")]), _vm._v(" Harlem, Part 3 (Today’s Harlem)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/44chapter38#ch38"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("38.")]), _vm._v(" The Cloisters and Fort Tryon Park")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/45chapter39#ch39"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("39.")]), _vm._v(" Brooklyn: DUMBO (Down Under the Manhattan Bridge Overpass)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/46chapter40#ch40"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("40.")]), _vm._v(" Williamsburg")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/47chapter41#ch41"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("41.")]), _vm._v(" The Brooklyn Bridge Park Greenway")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/48chapter42#ch42"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("42.")]), _vm._v(" Brooklyn Heights")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/49chapter43#ch43"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("43.")]), _vm._v(" Brooklyn: Cobble Hill and Carroll Gardens")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/50chapter44#ch44"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("44.")]), _vm._v(" Brooklyn: Farmers’ Market, the Brooklyn Museum, and the Botanic Garden")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/51chapter45#ch45"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("45.")]), _vm._v(" Brooklyn: Prospect Park")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/52chapter46#ch46"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("46.")]), _vm._v(" Brooklyn: Park Slope")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/53chapter47#ch47"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("47.")]), _vm._v(" Fort Greene")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/54chapter48#ch48"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("48.")]), _vm._v(" Bushwick")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/55chapter49#ch49"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("49.")]), _vm._v(" Red Hook")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/56chapter50#ch50"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("50.")]), _vm._v(" Governors Island")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64733c10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05-contents.vue
// module id = 69
// module chunks = 0